import React, { useMemo } from 'react';

import useEvent from '@lyearn/core/hooks/useEvent';
import { FilterManagerReturnType } from '@/modules/learner/views/LearnerProfile/components/LearnerProfileEntity/types';

import { FilterState, SortState } from './types';

export default function useFilterManagerWithState({
  defaultSortBy = [],
  defaultFilters = {},
  defaultSearch = '',
}: {
  defaultSortBy?: SortState;
  defaultFilters?: FilterState;
  defaultSearch?: string;
}): FilterManagerReturnType {
  const [sort, setSort] = React.useState<SortState>(defaultSortBy);
  const [filter, setFilter] = React.useState<FilterState>(defaultFilters);
  const [search, setSearch] = React.useState<string>(defaultSearch);

  const clearSearchAndFilters = useEvent(() => {
    setFilter(defaultFilters);
    setSearch(defaultSearch);
  });

  const methods = useMemo(
    () => ({
      setSort(sortState: SortState) {
        setSort(sortState);
      },
      setFilter(filterState: FilterState) {
        setFilter(filterState);
      },
      setSearch(searchState: string) {
        setSearch(searchState);
      },
      clearFilters() {
        setFilter(defaultFilters);
      },
      clearSearch() {
        setSearch(defaultSearch);
      },
      clearSort() {
        setSort(defaultSortBy);
      },
      clearSearchAndFilters,
    }),
    [clearSearchAndFilters, defaultFilters, defaultSearch, defaultSortBy],
  );

  return {
    state: {
      sort,
      filter,
      search,
      defaultFilters,
      defaultSearch,
    },
    methods,
  };
}
